module.exports = __webpack_public_path__ + "img/loan_1.3e2a9a15.png";